module.exports = __webpack_public_path__ + "img/145.dd556f4e.jpg";